// Authentication route constants
export const authRoutes = {
  // Frontend routes
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_SENT: "/forgot-password/sent",
  RESET_PASSWORD: "/reset-password",
  GOOGLE_CALLBACK: "/auth/google/callback",

  // Dashboard routes - redirects after auth
  DASHBOARD: "/agents",
  SETTINGS: "/settings/profile",

  // Modal routes
  MODAL_LOGIN: "/?showLogin=true",
  MODAL_SIGNUP: "/?showSignup=true",
  MODAL_FORGOT_PASSWORD: "/?showForgotPassword=true",

  // Public config endpoint
  PUBLIC_CONFIG: "/public-config",
};

// Backend API endpoints for auth (relative to /api/v1 base URL)
export const apiAuthEndpoints = {
  LOGIN: "/auth/login/access-token",
  REFRESH_TOKEN: "/auth/login/refresh-token",
  LOGOUT: "/auth/logout",
  SIGNUP: "/auth/signup",
  PASSWORD_RECOVERY: "/auth/password-recovery",
  RESET_PASSWORD: "/auth/reset-password/",
  GOOGLE_LOGIN: "/auth/google/login",
  GOOGLE_CALLBACK: "/auth/google/callback",
  GOOGLE_EXCHANGE_TOKEN: "/auth/google/exchange-token",
};
